import { FinancialSettlementAdvancePayment } from '@dreryk/egabinet-financial-settlement-frontend-api';

import { StyledFlex } from '@dreryk/react-components';

import { OnRefundSuccessCallback } from '~libs.desktop.shared.refund-advance-payment';

import { VisitMedicalServiceTableBean } from '../medicalServices/medicalServices.types';
import { getMedicalServicePrices } from '../medicalServices/medicalServices.utils';
import { MedicalServicesTotalPriceText } from '../medicalServices/MedicalServicesTotalPriceText';
import { MedicalServicesPrices } from '../medicalServices/prices/MedicalServicesPrices';

import { AdjustmentFormBean } from './adjustment/adjustment.types';
import { VisitDetailsFormBean } from './visitDetails/visitDetails.types';
import { areAdvancePaymentsAvailable } from './VisitSettlementForm.utils';
import { StyledBottomElement } from './VisitSettlementFormMedicalServicesPrices.styled';

type VisitSettlementFormMedicalServicesPricesProps = {
   readonly adjustment?: AdjustmentFormBean;
   readonly editable: boolean;
   readonly medicalServices: VisitMedicalServiceTableBean[];
   readonly advancePayments?: FinancialSettlementAdvancePayment[];
   readonly visitDetails?: VisitDetailsFormBean;
   readonly onRefundSuccess?: OnRefundSuccessCallback;
};

export const VisitSettlementFormMedicalServicesPrices = (
   props: VisitSettlementFormMedicalServicesPricesProps
): JSX.Element => {
   return (
      <StyledFlex gap={'4px'} alignItems={'center'}>
         <StyledBottomElement alignItems={'center'} justifyContent={'end'} gap={16} $editable={props.editable}>
            {areAdvancePaymentsAvailable(props.advancePayments) && props.visitDetails ? (
               <MedicalServicesPrices
                  adjustment={props.adjustment}
                  medicalServicesPrices={getMedicalServicePrices(props.medicalServices)}
                  visitDetails={props.visitDetails}
                  advancePayments={props.advancePayments}
                  onRefundSuccess={props.onRefundSuccess}
               />
            ) : (
               <MedicalServicesTotalPriceText medicalServices={props.medicalServices} />
            )}
         </StyledBottomElement>
      </StyledFlex>
   );
};
